import { MenuDivider, MenuGroup, MenuItem } from '@chakra-ui/react';
import React from 'react';

import { type ReferenceMap } from '@rta/rta-blueprint-library';

import { ComponentController } from '@r-core';
import { type ContextData, type ContextMenuList, type ContextMenuListDivider, type ContextMenuListGroup, type ContextMenuListItem, type ContextMenuListSubMenu, ContextMenuListItemType } from './types';
import { renderSubMenu } from './submenu';

export type RenderMenuState = {
	context: ContextData;
	position: { x: number; y: number };
	refMap: ReferenceMap;
	controller: ComponentController;
};

export type RenderMenu = {
	menuList: Array<ContextMenuList>;
	state: RenderMenuState;
};

export const renderMenu = ({ menuList, state }: RenderMenu): Array<React.ReactElement> => {
	let itemCount = 0;
	return menuList.map((menuItem, index) => {
		let item = null;
		switch (menuItem.type) {
			case ContextMenuListItemType.Item:
				itemCount++;
				item = menuItem as ContextMenuListItem;
				return (
					<MenuItem
						key={index}
						{...item.itemProps}
						onClick={() => {
							item.onClick(state);
						}}
						isDisabled={
							!(
								typeof menuItem.isEnabled === 'undefined' ||
								(typeof menuItem.isEnabled === 'boolean' && menuItem.isEnabled) ||
								(typeof menuItem.isEnabled === 'function' && menuItem.isEnabled({ controller: state.controller }))
							)
						}
					>
						{typeof item.content === 'function' ? item.content({ context: state.context, controller: state.controller, refMap: state.refMap }) : item.content}
					</MenuItem>
				);
			case ContextMenuListItemType.Group:
				item = menuItem as ContextMenuListGroup;
				return (
					<MenuGroup key={index} title={item.title}>
						{renderMenu({ menuList: item.items, state })}
					</MenuGroup>
				);
			case ContextMenuListItemType.SubMenu:
				itemCount++;
				item = menuItem as ContextMenuListSubMenu;
				return renderSubMenu(item, state, index, renderMenu);
			default:
				if (itemCount > 0) {
					item = menuItem as ContextMenuListDivider;
					return <MenuDivider key={index} {...item.itemProps} />;
				}
				return null;
		}
	});
};
